// ABOUTME: Child-facing neutral Reset control — starts a child-initiated crossing (Issue #1939).
// ABOUTME: Surfaces a short inline error on failure since no parent is necessarily present to notice.

import { useState } from 'react';
import { Button, Typography } from '@mui/material';
import api from '../../services/api';
import type { CrossingDto } from '../../types/api';

interface ResetControlProps {
  slug: string;
  token?: string;
  onStarted: (crossingId: number) => void;
}

export default function ResetControl({ slug, token, onStarted }: ResetControlProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleClick = async () => {
    setIsSubmitting(true);
    setHasError(false);
    try {
      const response = await api.post<CrossingDto>(
        `/api/child/${slug}/crossings`,
        undefined,
        { params: token ? { token } : {} }
      );
      onStarted(response.data.id);
    } catch {
      setHasError(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button variant="outlined" color="inherit" disabled={isSubmitting} onClick={handleClick}>
        Reset
      </Button>
      {hasError && (
        <Typography variant="body2" color="error">
          Couldn&apos;t start — try again
        </Typography>
      )}
    </>
  );
}
